<div class="experience-courses-monitoring-view-part">
	This is experience-courses-page monitoring view
</div>